import { createContext, useContext, useReducer } from 'react';
import { PlanQuizFlow, PlanQuizStep, STEP_BACK_MAP } from './planQuizConstants';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultState = {
  step: PlanQuizStep.EMAIL_INPUT,
  flow: PlanQuizFlow.EMAIL_LINK,
  emailOrLink: '',
  selectedUseCases: [],
  teamSize: null,
  recommendation: null,
  recommendationId: null,
  seatsQuantity: 1,
  error: null
};
function planQuizReducer(state, action) {
  switch (action.type) {
    case 'SELECT_FLOW':
      {
        const nextStep = action.flow === PlanQuizFlow.EMAIL_LINK ? PlanQuizStep.EMAIL_INPUT : PlanQuizStep.QUIZ_USE_CASES;
        return Object.assign({}, state, {
          flow: action.flow,
          step: nextStep
        });
      }
    case 'GO_BACK':
      {
        const prevStep = STEP_BACK_MAP[state.step];
        if (!prevStep) return state;
        if (prevStep === PlanQuizStep.EMAIL_INPUT) {
          return Object.assign({}, defaultState, {
            step: prevStep
          });
        }
        return Object.assign({}, state, {
          step: prevStep
        });
      }
    case 'SET_STEP':
      return Object.assign({}, state, {
        step: action.step
      });
    case 'SET_EMAIL_OR_LINK':
      return Object.assign({}, state, {
        emailOrLink: action.value
      });
    case 'TOGGLE_USE_CASE':
      {
        const useCases = state.selectedUseCases.includes(action.useCase) ? state.selectedUseCases.filter(uc => uc !== action.useCase) : [...state.selectedUseCases, action.useCase];
        return Object.assign({}, state, {
          selectedUseCases: useCases
        });
      }
    case 'SET_TEAM_SIZE':
      return Object.assign({}, state, {
        teamSize: action.size
      });
    case 'SET_RECOMMENDATION':
      return Object.assign({}, state, {
        recommendation: action.recommendation
      });
    case 'SET_RECOMMENDATION_ID':
      return Object.assign({}, state, {
        recommendationId: action.id
      });
    case 'SET_CORE_SEATS':
      return Object.assign({}, state, {
        seatsQuantity: action.quantity
      });
    case 'SET_ERROR':
      return Object.assign({}, state, {
        error: action.error
      });
    case 'RESET':
      return defaultState;
    case 'RESET_TO_STEP':
      /* Used by the in-app skip-to-results fetcher to clear a prior
         recommendation before it starts a fresh request each time the modal
         reopens. Preserves flow (the in-app seed is PlanQuizFlow.IN_APP) so the
         reset doesn't drop the flow discriminator from the quiz's events. */
      return Object.assign({}, defaultState, {
        step: action.step,
        flow: state.flow
      });
    default:
      return state;
  }
}
const PlanQuizStateContext = /*#__PURE__*/createContext(defaultState);
const PlanQuizDispatchContext = /*#__PURE__*/createContext(() => {});
export const PlanQuizProvider = ({
  children,
  initialStep,
  initialFlow
}) => {
  const [state, dispatch] = useReducer(planQuizReducer, initialStep ? Object.assign({}, defaultState, {
    step: initialStep,
    flow: initialFlow !== null && initialFlow !== void 0 ? initialFlow : null
  }) : defaultState);
  return /*#__PURE__*/_jsx(PlanQuizStateContext.Provider, {
    value: state,
    children: /*#__PURE__*/_jsx(PlanQuizDispatchContext.Provider, {
      value: dispatch,
      children: children
    })
  });
};
export const usePlanQuizState = () => useContext(PlanQuizStateContext);
export const usePlanQuizDispatch = () => useContext(PlanQuizDispatchContext);